import { center } from '@onbeam/business-styled-system/patterns';
import { ComponentProps } from 'react';

export const NewsVideoActionButton = (props: ComponentProps<'button'>) => (
  <button
    type="button"
    className={center({
      cursor: 'pointer',
      color: 'mono.tertiary',
      p: '2.5',
      rounded: 'full',
      bg: '[rgba(0, 0, 0, 0.02)]',
      backdropFilter: '[blur(5px)]',
      transition: 'colors',

      _hoverFocus: {
        bg: '[rgba(0, 0, 0, 0.2)]',
      },
    })}
    {...props}
  />
);
